// A family member's figure as a flat toy icon (Who cards, family list, configurator fallback):
// the same coat, hat and scarf as their 3D figure (stage/who/figure3d.ts).
import type { Figure } from '../../shared/family'
import { hex } from '../../shared/figures'

const INK = '#1B2A3A'

export function FigureIcon({ figure, size = 48 }: { figure: Figure; size?: number }) {
  const coat = hex(figure.coat)
  const legs = hex(figure.legs ?? 0x1b2a3a)
  const hat = hex(figure.hat ?? 0xff4f4f)
  const kind = figure.hatKind ?? 'beanie'
  return (
    <svg width={size} height={size * 1.1} viewBox="-30 -70 60 80" aria-hidden="true">
      {figure.prop === 'board' || figure.prop === 'skis' ? (
        <rect x="-26" y="2" width="52" height="7" rx="3.5" fill={figure.prop === 'board' ? '#B3121E' : hat} stroke={INK} strokeWidth="2.5" />
      ) : null}
      <rect x="-11" y="-16" width="9" height="20" rx="4.5" fill={legs} stroke={INK} strokeWidth="2.5" />
      <rect x="2" y="-16" width="9" height="20" rx="4.5" fill={legs} stroke={INK} strokeWidth="2.5" />
      <path d="M-13,-40 Q0,-46 13,-40 L17,-12 Q0,-7 -17,-12 Z" fill={coat} stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
      <rect x="-23" y="-38" width="9" height="22" rx="4.5" fill={coat} stroke={INK} strokeWidth="2.5" transform="rotate(14 -18 -38)" />
      <rect x="14" y="-38" width="9" height="22" rx="4.5" fill={coat} stroke={INK} strokeWidth="2.5" transform="rotate(-14 18 -38)" />
      {figure.scarf !== undefined ? <rect x="-12" y="-44" width="24" height="7" rx="3.5" fill={hex(figure.scarf)} stroke={INK} strokeWidth="2.2" /> : null}
      <circle cx="0" cy="-52" r="11" fill="#FFE2C4" stroke={INK} strokeWidth="2.5" />
      <circle cx="-4" cy="-51" r="1.6" fill={INK} />
      <circle cx="4" cy="-51" r="1.6" fill={INK} />
      {kind === 'beanie' || kind === 'hood' ? <path d="M-11.5,-54 a11.5,11.5 0 0 1 23,0z" fill={hat} stroke={INK} strokeWidth="2.5" /> : null}
      {kind === 'beanie' ? <circle cx="0" cy="-66" r="4" fill="#fff" stroke={INK} strokeWidth="2" /> : null}
      {kind === 'cap' ? <path d="M-11,-56 h22 v-5 a11,6 0 0 0 -22,0z M4,-56 h12 v3 h-12z" fill={hat} stroke={INK} strokeWidth="2.2" /> : null}
      {kind === 'earmuffs' ? (
        <>
          <path d="M-11,-54 a11,11 0 0 1 22,0" fill="none" stroke={INK} strokeWidth="2.5" />
          <circle cx="-11" cy="-52" r="4.5" fill={hat} stroke={INK} strokeWidth="2" />
          <circle cx="11" cy="-52" r="4.5" fill={hat} stroke={INK} strokeWidth="2" />
        </>
      ) : null}
      {kind === 'none' ? <path d="M-11,-55 a11,9 0 0 1 22,0z" fill="#6b4a33" stroke={INK} strokeWidth="2.2" /> : null}
    </svg>
  )
}

/** The card behind an icon: a lighter-to-coat gradient. */
export const figureBg = (f: Figure) => `linear-gradient(180deg, ${hex(f.coat)}88, ${hex(f.coat)})`
